export enum Material {
    CANVAS = "Acryl op doek",
    PAPER = "Acryl op papier",
    WOOD = "Acryl op hout",
    CARTON = "Acryl op karton",
    COLLAGE_CANVAS = "Acryl + collage op doek",
    COLLAGE_CARTON = "Acryl + collage op karton",
    MIXED_CANVAS = "Gemengde technieken op doek",
    AQUAREL_CANVAS= "Aquarel op doek"
}
